/**
 * Construct the group map key to be a combination of GroupId and primarySmtpAddress as the
 * standard groups' GroupIds are same across accounts
 */
export default function getCalendarGroupKey(primarySmtpAddress: string, groupId: string): string {
    return `${groupId}_${primarySmtpAddress}`;
}
